

const PrivacyPolicy = () => {
  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white p-8 sm:p-10 rounded-lg shadow-md">
          
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">
            Privacy Policy
          </h1>
          <p className="text-lg text-gray-600 mb-4">
            (Informativa sul trattamento dei dati personali)
          </p>
          <p className="text-sm text-gray-500 mb-8 italic">
            ai sensi dell'art. 13 del Regolamento (UE) 2016/679 (GDPR) <br />
          </p>

          <div className="space-y-6 text-gray-700 leading-relaxed">
            <p>
              La presente informativa descrive le modalità di gestione del sito web in riferimento al trattamento dei dati personali degli utenti che lo consultano. La nostra politica è improntata alla massima trasparenza e al rispetto della privacy, in conformità con la normativa vigente.
            </p>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-3">
                1. Titolare del Trattamento
              </h2>
              <p>Il Titolare del trattamento dei dati è:</p>
              <div className="mt-2 pl-4 border-l-4 border-gray-200">
                <p><strong>Nome Azienda:</strong> Azienda Agricola Beverahills di Bonfanti Giuseppe</p>
                <p><strong>Sede Legale:</strong> Via Santuario inferiore 9, Barzago, LC</p>
                <p><strong>Partita IVA / C.F.:</strong> 02276940133 / BNFGPP69L12G009I</p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-3">
                2. Tipologia di Dati Trattati e Finalità
              </h2>
              <p>
                Il nostro sito è stato progettato per essere uno strumento puramente informativo, con l'obiettivo di ridurre al minimo la raccolta di dati personali.
              </p>
              <p>
                <strong>Dati di Navigazione:</strong> I sistemi informatici e le procedure software preposte al funzionamento di questo sito web acquisiscono, nel corso del loro normale esercizio, alcuni dati la cui trasmissione è implicita nell'uso dei protocolli di comunicazione di Internet. Si tratta di informazioni che non sono raccolte per essere associate a interessati identificati, ma che per loro stessa natura potrebbero, attraverso elaborazioni ed associazioni con dati detenuti da terzi, permettere di identificare gli utenti (es. indirizzi IP, tipo di browser, orario della richiesta). Questi dati vengono utilizzati al solo fine di ricavare informazioni statistiche <strong>anonime e aggregate</strong> sull'uso del sito e per controllarne il corretto funzionamento.
              </p>
              <p>
                <strong>Dati Forniti Volontariamente dall'Utente:</strong> <strong>Questo sito non raccoglie dati personali forniti volontariamente.</strong> Non sono presenti moduli di contatto, sezioni per la registrazione, aree commenti o altri strumenti che richiedano l'inserimento di informazioni personali.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-3">
                3. Utilizzo di Google Search Console
              </h2>
              <p>
                Per monitorare le prestazioni del nostro sito nei risultati di ricerca di Google e per ottimizzarne l'indicizzazione, utilizziamo il servizio Google Search Console. Desideriamo chiarire che Google Search Console <strong>non raccoglie dati personali dei visitatori del sito</strong>. Il servizio fornisce al Titolare del Trattamento dati esclusivamente <strong>aggregati e anonimi</strong>, come le query di ricerca che hanno portato al sito, il numero di click e le impressioni. Nessuna di queste informazioni può essere ricondotta a un singolo utente identificabile.
              </p>
              <p>
                Per maggiori informazioni, si può consultare la privacy policy di Google: 
                <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 hover:underline ml-1">
                  https://policies.google.com/privacy
                </a>.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-3">
                4. Diritti dell'Interessato
              </h2>
              <p>
                Poiché questo sito non raccoglie né conserva dati personali identificativi, l'esercizio dei diritti previsti dal GDPR (accesso, rettifica, cancellazione, etc.) potrebbe non essere applicabile. Per qualsiasi domanda, è possibile contattare il Titolare all'indirizzo email indicato al punto 1.
              </p>
            </section>
            
            <section>
              <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-3">
                5. Periodo di Conservazione dei Dati
              </h2>
              <p>
                    I dati di navigazione, non essendo associati a utenti identificati, non vengono conservati ma cancellati poco dopo la loro aggregazione a fini statistici e di sicurezza. Non essendo raccolto alcun altro dato personale, non si applicano ulteriori periodi di conservazione.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-3">
                6. Social buttons e widgets
              </h2>
              <p>
Nel Sito sono presenti anche social buttons/widgets. Si tratta in particolare delle icone dei social network, quali, ad esempio, Facebook, Google e Instagram, che consentono all’Interessato di raggiungere - per il tramite di un "click" sull’icona – i relativi social network. Con il supporto di questi strumenti l’Interessato può condividere dei contenuti o consigliare dei prodotti del Sito nei social network.

A seguito di click sui social buttons/widgets, il social network potrebbe raccogliere i Dati relativi alla visita sul Sito dell’Interessato. Come anticipato in premessa, la presente informativa in materia di Trattamento di Dati Personali non inerisce il Trattamento dei Dati da parte del social network per il quale l’Interessato deve fare riferimento esclusivamente all’informativa privacy fornita dal social network; il Titolare non diffonde o condivide alcun dato personale con il social network se non fornito o condiviso da parte dell’Interessato in modo spontaneo per il tramite di click sui social button/widgets.              </p>
            </section>

          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;